import {combineReducers} from 'redux';

import {type Action} from 'web-app/util/redux/action-types';

import employeeContactsReducer, {type EmployeeContactsReducer} from './employee-contacts/reducer';
import kibig, {type KibigReducer} from './kibig/reducer';
import employeeId from './employee-id/reducer';
import keyChildren, {type KeyChildrenReducer} from './key-children/reducer';
import basicInfoReducer, {type BasicInfoState} from './basic-info/reducer';
import aboutReducer, {type AboutState} from './about/reducer';
import tagReducer, {type TagState} from './tags/reducer';

export interface EmployeeProfileState {
    kibig: KibigReducer;
    employeeContacts: EmployeeContactsReducer;
    employeeId: any;
    keyChildren: KeyChildrenReducer;
    about: AboutState;
    basicInfo: BasicInfoState;
    tags: TagState;
}

export default combineReducers<EmployeeProfileState, Action<any>>({
    kibig,
    employeeContacts: employeeContactsReducer,
    employeeId,
    about: aboutReducer,
    basicInfo: basicInfoReducer,
    keyChildren,
    tags: tagReducer,
});
